import { Link } from 'react-router-dom'
import { BrandLogo } from './BrandLogo'
import {
  FOOTER_COLUMNS,
  FOOTER_COMING_SOON_LABEL,
  FOOTER_COPY,
  SOCIAL_ICON_SIZE,
  SOCIAL_LINKS,
} from '../constants/footer'
import '../styles/footer.scss'

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <BrandLogo />
          <p className="footer-brand__kicker">
            {FOOTER_COPY.kicker.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </p>
          <p>{FOOTER_COPY.blurb}</p>
          <p className="footer-brand__tagline">{FOOTER_COPY.tagline}</p>
          <p className="footer-note">{FOOTER_COPY.note}</p>
        </div>

        {FOOTER_COLUMNS.map((column) => (
          <div key={column.title} className="footer-column">
            <h3>{column.title}</h3>
            <ul>
              {column.links.map((link) => (
                <li key={link.label}>
                  {link.comingSoon || !link.to ? (
                    <span className="footer-link--soon">
                      {link.label}
                      <span className="footer-badge">{FOOTER_COMING_SOON_LABEL}</span>
                    </span>
                  ) : (
                    <Link to={link.to}>{link.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}

      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom__inner">
          <p>
            © {new Date().getFullYear()} {FOOTER_COPY.company}
          </p>
          <div className="footer-social">
            {SOCIAL_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noreferrer"
                aria-label={link.label}
                title={link.label}
              >
                <img
                  src={link.iconSrc}
                  alt=""
                  width={SOCIAL_ICON_SIZE}
                  height={SOCIAL_ICON_SIZE}
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
